export const floatRegex = /^\d*\.?\d*$/;
// Regex explanation:
// ^ - Beginning of the line
// \d* - 0 or more digits
// \.? - An optional dot (escaped, because in regex, . is a special character)
// \d* - 0 or more digits (the decimal part)
// $ - End of the line
